import type { FaireProductEntity } from "../../entity_types/product";

export const p_uwbu9ubj9q: FaireProductEntity = {
  token: "p_uwbu9ubj9q",
  type: "product",
  name: "Thanks a Bunch Flowers Wrapped in Banner Thank You Card",
  brandToken: "b_qat8n5mmyf",
  brandName: "Willow & Ivy Press",
  imageUrl:
    "https://cdn.faire.com/fastly/0dd01610cb15970d0c78eee7129c8d32822bc5702ad299feb6cf039c00b98629.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b159ee93632269d185927483ebbfc646d30ead173b9f2e10e868193a51dfc90c.png",
  ],
  priceDollars: 18,
  description:
    "Willow & Ivy Greeting Cards print on heavy, uncoated paper stock with foil, glitter, and die-cut embellishments. Each card includes a Champagne Gold Pearlized envelope for a timeless look and touch. All cards are made in the USA.\n\n• 6 Cards & Envelopes per unit\n• Wholesale: $18.00/unit\n• Retail: $6.00 each\n• Please note: Cards are not individually cello-wrapped and include the retail price printed on the back.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:09.742Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
